module.exports = __webpack_public_path__ + "img/kel-unid-sjp.653291dc.jpg";